/**
 * @flow
 * @relayHash 9349b91c502df2eb38231c17112b5c43
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateVendorItemPriceInput = {|
  id: string,
  unitPrice?: ?number,
  leadTimeDays?: ?number,
  isPreferred?: ?boolean,
|};
export type UpdateVendorItemPriceMutationVariables = {|
  input: UpdateVendorItemPriceInput
|};
export type UpdateVendorItemPriceMutationResponse = {|
  +updateVendorItemPrice: {|
    +vendorItemPrice: {|
      +id: string,
      +vendor: {|
        +id: string
      |},
      +item: {|
        +id: string,
        +name: string,
      |},
      +unitPrice: number,
      +leadTimeDays: number,
      +isPreferred: boolean,
      +createdAt: any,
    |}
  |}
|};
export type UpdateVendorItemPriceMutation = {|
  variables: UpdateVendorItemPriceMutationVariables,
  response: UpdateVendorItemPriceMutationResponse,
|};
*/


/*
mutation UpdateVendorItemPriceMutation(
  $input: UpdateVendorItemPriceInput!
) {
  updateVendorItemPrice(input: $input) {
    vendorItemPrice {
      id
      vendor {
        id
      }
      item {
        id
        name
      }
      unitPrice
      leadTimeDays
      isPreferred
      createdAt
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateVendorItemPriceInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateVendorItemPrice",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateVendorItemPricePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "vendorItemPrice",
        "storageKey": null,
        "args": null,
        "concreteType": "VendorItemPrice",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "vendor",
            "storageKey": null,
            "args": null,
            "concreteType": "Vendor",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": null,
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "unitPrice",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "leadTimeDays",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isPreferred",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateVendorItemPriceMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateVendorItemPriceMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateVendorItemPriceMutation",
    "id": null,
    "text": "mutation UpdateVendorItemPriceMutation(\n  $input: UpdateVendorItemPriceInput!\n) {\n  updateVendorItemPrice(input: $input) {\n    vendorItemPrice {\n      id\n      vendor {\n        id\n      }\n      item {\n        id\n        name\n      }\n      unitPrice\n      leadTimeDays\n      isPreferred\n      createdAt\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f6ad0b53064851f2449cc5af15f8d969';
module.exports = node;
